module.exports = __webpack_public_path__ + "img/product05-chanpin.77167ff0.svg";